import React from "react";

// Breadcrumb icon for the current facility crumb (Settings › Facilities › {name}) — Figma
// "Icons/Hospital 3" (component 4012:3904) exported 1:1, recolored to black for the white card.
const FacilityNameIcon = ({ style = {} }) => {
  return (
    <svg style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.086 15.825V8.175M14.916 15.825V8.175M9.086 12H14.917M7.783 3H16.218C19.166 3 21 5.081 21 8.026V15.974C21 18.919 19.166 21 16.217 21H7.783C4.835 21 3 18.919 3 15.974V8.026C3 5.081 4.844 3 7.783 3Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FacilityNameIcon;
